import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const RS: DeepPartial<Payments> = {
    isPrioritizedGroupAccountsSearchEnabled: true,
    redoReplyEngine: 'paymentService',
    shouldPrefillSenderNameFromAccount: false,
    maxDaysInFuture: 60,
};
